import { Routes } from "@angular/router";
import { RoleGuard } from "../Authentication/guards/role.guard";
import { CanDeactivateOrderActivityGuard } from "./components/order-activity/can-deactivate-order-activity-guard.service";
import { NgxPermissionsRouterData } from "ngx-permissions";
import { Role } from "../Authentication/models/roles-permissions.model";

export const VENDOR_ROUTES: Routes = [
    {
        path: "",
        loadComponent: () =>
            import("./layouts/main-vendor-layout/main-vendor-layout.component").then(
                (m) => m.MainVendorLayoutComponent
            ),
        canActivate: [RoleGuard],
        data: {
            roles: {
                only: [Role.Vendor, Role.WholeSaler],
                redirectTo: "/error/access-denied",
            } as NgxPermissionsRouterData,
        },
        children: [
            {
                path: "dashboard",
                loadComponent: () =>
                    import("./components/supplier-dashboard/supplier-dashboard.component").then(
                        (m) => m.SupplierDashboardComponent
                    ),
            },
            {
                path: "profile",
                loadComponent: () =>
                    import("./components/vendor-profile/vendor-profile.component").then(
                        (m) => m.VendorProfileComponent
                    ),
            },
            {
                path: "search",
                loadComponent: () =>
                    import("./components/vendor-search-bar/vendor-search-bar.component").then(
                        (m) => m.VendorSearchBarComponent
                    ),
            },
            {
                path: "product-listing",
                loadComponent: () =>
                    import("./components/vendor-product-listing/vendor-product-listing.component").then(
                        (m) => m.VendorProductListingComponent
                    ),
            },
            {
                path: "add-item",
                loadComponent: () =>
                    import("../Shared/components/add-item-for-vendor/add-item-for-vendor.component").then(
                        (m) => m.AddItemForVendorComponent
                    ),
            },
            {
                path: "add-product",
                loadComponent: () =>
                    import("../Shared/components/vendor-tabs/vendor-tabs.component").then(
                        (m) => m.VendorTabsComponent
                    ),
            },
            {
                path: "view-product/:item/:style",
                loadComponent: () =>
                    import("../Shared/components/vendor-product-details/vendor-product-details.component").then(
                        (m) => m.VendorProductDetailsComponent
                    ),
            },
            {
                path: "my-store",
                loadComponent: () =>
                    import("./components/supplier-store/supplier-store.component").then(
                        (m) => m.SupplierStoreComponent
                    ),
            },
            {
                path: "addBannerForStore/:vendor",
                loadComponent: () =>
                    import("./components/add-banner-social-links-for-store/add-banner-social-links-for-store.component").then(
                        (m) => m.AddBannerSocialLinksForStoreComponent
                    ),
            },
            {
                path: "pricing-plans",
                loadComponent: () =>
                    import("../Customer/components/pricing-plans/pricing-plans.component").then(
                        (m) => m.PricingPlansComponent
                    ),
            },
            {
                path: "giTags",
                loadComponent: () =>
                    import("../Admin/components/gi-tags-approval/gi-tags-approval.component").then(
                        (m) => m.GiTagsApprovalComponent
                    ),
            },
            {
                path: "subscription-management",
                loadComponent: () =>
                    import("../Customer/components/pricing-plans/subscription-management/subscription-management.component").then(
                        (m) => m.SubscriptionManagementComponent
                    ),
            },
            {
                path: "order-activity",
                canDeactivate: [CanDeactivateOrderActivityGuard],
                children: [
                    {
                        path: "",
                        loadComponent: () =>
                            import("./components/order-activity/order-activity.component").then(
                                (m) => m.OrderActivityComponent
                            ),
                    },
                    {
                        path: ":orderId/order-actions",
                        loadComponent: () =>
                            import("./components/order-activity/order-actions/order-actions.component").then(
                                (m) => m.OrderActionsComponent
                            ),
                    },
                    {
                        path: ":orderId/order-activity-details",
                        loadComponent: () =>
                            import("./components/order-activity/order-details-activity/order-details-activity.component").then(
                                (m) => m.OrderDetailsActivityComponent
                            ),
                    },
                    {
                        path: "refundStatus/:webOrder/:refundId",
                        loadComponent: () =>
                            import("./components/order-activity/refund-status/refund-status.component").then(
                                (m) => m.RefundStatusComponent
                            ),
                    },
                    {
                        path: "shippingLabel/:webOrder",
                        loadComponent: () =>
                            import("./components/shipping-label/shipping-label.component").then(
                                (m) => m.ShippingLabelComponent
                            ),
                    },
                ],
            },
            {
                path: "stock/:catalogItemStyle",
                loadComponent: () =>
                    import("../Shared/components/vendor-stock/vendor-stock.component").then(
                        (m) => m.VendorStockComponent
                    ),
            },
            {
                path: "returns",
                loadComponent: () =>
                    import("./components/incomplete-returns/incomplete-returns.component").then(
                        (m) => m.IncompleteReturnsComponent
                    ),
            },
            {
                path: "exchanges",
                loadComponent: () =>
                    import("./components/vendor-exchanges/vendor-exchanges.component").then(
                        (m) => m.VendorExchangesComponent
                    ),
            },
            {
                path: "returnStatus/:webOrderDetail",
                loadComponent: () =>
                    import("../Customer/components/order-related/return-status/return-status.component").then(
                        (m) => m.ReturnStatusComponent
                    ),
            },
            {
                path: "trackOrder/:webOrderDetail",
                loadComponent: () =>
                    import("../Customer/components/order-related/track-order/track-order.component").then(
                        (m) => m.TrackOrderComponent
                    ),
            },
            {
                path: "customer-queries",
                loadComponent: () =>
                    import("./components/customer-queries/customer-queries.component").then(
                        (m) => m.CustomerQueriesComponent
                    ),
            },
            {
                path: "view-customer-query",
                loadComponent: () =>
                    import("../Shared/components/view-customer-query/view-customer-query.component").then(
                        (m) => m.ViewCustomerQueryComponent
                    ),
            },
            {
                path: "refund-item",
                loadComponent: () =>
                    import("./components/refund-item/refund-item.component").then(
                        (m) => m.RefundItemComponent
                    ),
            },
            {
                path: "verifyVendor",
                loadComponent: () =>
                    import("./components/verify-vendor/verify-vendor.component").then(
                        (m) => m.VerifyVendorComponent
                    ),
            },
            {
                path: "sales-breakdown",
                loadComponent: () =>
                    import("./components/sales-breakdown/sales-breakdown.component").then(
                        (m) => m.SalesBreakdownComponent
                    ),
            },
            {
                path: "view-supplier-query",
                loadComponent: () =>
                    import("./components/supplier-querry/supplier-querry.component").then(
                        (m) => m.SupplierQuerryComponent
                    ),
            },
            {
                path: "brands",
                loadComponent: () =>
                    import("../Shared/components/brand-tabs/brand-tabs.component").then(
                        (m) => m.BrandTabsComponent
                    ),
            },
        ],
    },
];